export const SET_ACTIVE_PAGE = "SET_ACTIVE_PAGE";
